import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-file-history-table',
	templateUrl: './file-history-table.component.html',
	styleUrls: ['./file-history-table.component.scss'],
})
export class FileHistoryTableComponent implements OnInit {
	displayedColumns: string[] = [
		'user',
		'modifiedField',
		'lastChange',
		'updateDate',
		'acts',
	];

	constructor() {}

	ngOnInit() {}
}
